import type { Workspace } from './api';

/** The one-letter mark for a workspace: its first character, whole, even where that is an emoji or other character outside the Basic Multilingual Plane. */
export function initial(name: string): string {
  return (Array.from(name.trim())[0] ?? '').toUpperCase();
}

/** A workspace's status in the list. One that can be opened is ready, whatever checkout it also has open. */
export function workspaceStatus(row: Pick<Workspace, 'recoveryRequired' | 'error' | 'state' | 'canOpen' | 'checkoutPlanId'>): string {
  if (row.recoveryRequired) return 'Recovery in progress';
  if (row.error) return 'Needs attention';
  if (row.state === 'ready' && !row.canOpen) return 'Verifying access';
  if (row.canOpen) return 'Ready';
  if (row.checkoutPlanId) return 'Checkout started';
  return ({ ready: 'Ready', provisioning: 'Preparing workspace', suspended: 'Access paused', awaiting_payment: 'Choose a plan' } as Record<string, string>)[row.state] ?? 'Checking status';
}
